// extracted by mini-css-extract-plugin
export const root = "header-module--root--2W5aJ";
export const appbarColorPrimary = "header-module--appbar-color-primary--3Tac5";
export const appbarLink = "header-module--appbar-link--iUKxd";
export const brand = "header-module--brand--ZCYCW";
export const brandIcon = "header-module--brand-icon--3KoCJ";
export const brandTitle = "header-module--brand-title--1jPrV";
export const accountButtonContainer = "header-module--accountButtonContainer--R8swb";
export const accountButton = "header-module--accountButton--31E8L";
export const avatarRoot = "header-module--avatar-root--2Iuui";